export default "__VITE_ASSET__DR16z7og__"